// Ported from dev-scrips-pm-react services/scheduling/use-patient-flags.ts (PROD-1190 calendar port)
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { FlagResponse } from '@/types/scheduling-api';

export function usePatientFlags(patientId: string | null) {
  return useQuery({
    queryKey: ['patient-flags', patientId],
    queryFn: ({ signal }) =>
      get<FlagResponse[]>(`/api/Appointment/PatientFlag?patientId=${patientId}`, { signal }),
    enabled: !!patientId,
  });
}
